import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<{ textColor?: string; hasIcon: boolean }>()(
  (theme, { textColor, hasIcon }) => ({
    button: {
      width: "100%",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(4),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      backgroundColor: "#ffffff",
      color: textColor || theme.palette.primary.main,
      textTransform: "none",
      fontWeight: 700,
      fontSize: "1.1rem",
      boxShadow: "0px 2px 0px #DEE4EB",
      border: `1px solid ${textColor || "#DEE4EB"}`,
      "&:hover": {
        backgroundColor: "#ffffff",
        boxShadow: "0px 2px 0px #DEE4EB",
        opacity: 0.8,
      },
    },
    buttonInner: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: hasIcon ? "space-around" : "center",
      gap: theme.spacing(2),
    },
    buttonIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);
